export type TextTransform = 'UPPER' | 'MIXED' | 'CAPITALIZE';
export const LOCAL_STORAGE_TEXT_TRANSFORM_KEY = 'CFS_TEXT_TRANSFORM';
export const DEFAULT_TEXT_TRANSFORM: TextTransform = 'UPPER';

export const applyTextTransformClassToBody = (textTransform?: TextTransform) => {
  const appliedTextTransform: TextTransform =
    textTransform ||
    (localStorage.getItem(LOCAL_STORAGE_TEXT_TRANSFORM_KEY) as TextTransform | null) ||
    DEFAULT_TEXT_TRANSFORM;

  document.body.classList.toggle('custom-settings-uppercase', appliedTextTransform === 'UPPER');
  document.body.classList.toggle(
    'custom-settings-capitalize',
    appliedTextTransform === 'CAPITALIZE'
  );
};
